import styled from "styled-components";

export const Container = styled.div`
  background-color: #f5f5f5;
  padding: 20px 10px;
  margin: 40px 0;
`;

export const Header = styled.p`
  font-size: 22px;
  line-height: 28px;
  font-weight: 900;
  padding-bottom: 10px;
  border-bottom: 1px solid #c5c5c5;
  margin: 0 10px 10px 10px;
  width: calc(100% - 20px);
`;
